const gridletDirectives = angular.module('gridletDirectives', []);

gridletDirectives.directive('baseGridlet', function(
  $compile,
  $rootScope,
  $timeout,
  gridletService,
  $uibModal,
  eventService
) {
  const legacyFleetScopes = new Set();

  function updateLegacyFleetIds(scope, enabled) {
    if (enabled) {
      legacyFleetScopes.add(scope);
    } else {
      legacyFleetScopes.delete(scope);
    }
    const owner = legacyFleetScopes.values().next().value;
    legacyFleetScopes.forEach(fleetScope => {
      fleetScope.usesLegacyFleetIds = fleetScope === owner;
    });
  }

  return {
    replace: true,
    restrict: 'E',
    templateUrl: '/modules/gridlets/gridlet/gridlet-module.html',
    scope: {
      settings: '=',
      view: '=',
      customizable: '=',
      filter: '=',
    },
    link: function(scope, element) {
      const tag = scope.settings.id + '-module';

      scope.$on('gridlet-register-export', function(event, handlers) {
        scope.exportHandlers = handlers;
        updateLegacyFleetIds(scope, handlers && handlers.legacyFleetIds);
      });

      const $contentElement = $compile(
        '<' +
        tag +
        ' settings="settings" view="view" filter="filter"></' +
        tag +
        '>'
      )(scope);

      $contentElement.data('id', scope.settings.id);
      element.children('.gridletContentArea').append($contentElement);

      scope.options = scope.settings.options;
      if (scope.settings.title === 'trains.driver-view-gridlet-module.title') {
        scope.settings.title = 'trains.driver-view-gridlet-module.captain-title';
      }
      scope.title = scope.settings.title;
      scope.item = scope.settings.item;
      scope.settings.fullscreen = false;

      eventService.on('gridster-item-transition-end', function(item) {
        if (item.targetScope.$parent.gridlet.id === scope.settings.id) {
          $contentElement.show();
          scope.$broadcast('gridlet-refresh');
          updateOptionsClasses();
        }
      });

      eventService.on('gridlet-resize-started', function(event, el) {
        if (
          scope.settings.id ===
          el
            .find('.gridletContentArea')
            .children()
            .data('id')
        ) {
          $contentElement.hide();
        }
      });

      eventService.on('gridlet-resize-stopped', function(event, el) {
        gridletService.updateLayout(scope.view, scope.settings.key, scope.item);
        if (
          scope.settings.id ===
          el
            .find('.gridletContentArea')
            .children()
            .data('id')
        ) {
          $timeout(function() {
            $contentElement.show(300);
          }, 500);

          $timeout(function() {
            gridletService.saveLayout();
          }, 100);

          $timeout(function(event) {
            scope.$broadcast('gridlet-update-data', event);
          }, 500);
        }
      });

      eventService.on('gridlet-dragging-started', function(event, el) {
        if (
          scope.settings.id ===
          el
            .find('.gridletContentArea')
            .children()
            .data('id')
        ) {
        }
      });

      eventService.on('gridlet-dragging-stopped', function(event, el) {
        gridletService.updateLayout(scope.view, scope.settings.key, scope.item);
        if (
          scope.settings.id ===
          el
            .find('.gridletContentArea')
            .children()
            .data('id')
        ) {
          $timeout(function() {
            gridletService.saveLayout();
          }, 200);
        }
      });

      $rootScope.$on('toggle-customization', function(event, args) {
        if (!args.customize) {
          gridletService.saveGridletName(scope.view, scope.settings.key, scope.settings.title);
        }
      });

      scope.$on('gridlet-init', function() {
        updateOptionsClasses();
      });

      const cancelUpdateEventListener = eventService.on(
        scope.settings.updateEvent,
        function (e, event) {
          scope.$broadcast('gridlet-update-data', event);
        }
      );

      scope.hideGridlet = function() {
        gridletService.hideGridlet(scope.view, scope.settings.key);
        scope.$emit('update-gridlet-list');
      };

      scope.fullscreenToggle = function() {
        scope.settings.fullscreen = !scope.settings.fullscreen;
        scope.settings = Object.assign({}, scope.settings);
      };

      eventService.on('update-gridlet-menu', function() {
        scope.settings.fullscreen = false;
        scope.settings = Object.assign({}, scope.settings);
      });

      function updateOptionsClasses() {
        for (let i = 1; i < 11; i++) {
          if (scope.item.sizeX === i) {
            element.parent().addClass('width-' + i);
          } else {
            element.parent().removeClass('width-' + i);
          }
        }
      }

      scope.modify = function(gridletName) {
        const modalInstance = $uibModal.open({
          templateUrl: '/modules/modals/modify-' + gridletName + '-module.html',
          controller: scope.settings.editCtrl,
          size: 'sm',
          //windowClass: 'medium-size-modal'
        });

        modalInstance.result.then(function() {}, function() {});
      };

      scope.$on('$destroy', function() {
        updateLegacyFleetIds(scope, false);
        cancelUpdateEventListener();
      });
    },
  };
});
